import "./NewEngineering.css";
import "./serviceEditor.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../../Images/Marine services 2.jpg.jpeg';
import Aboutbg from '../../Images/new_m_1.png';
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";

const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

const DEFAULT_DATA = {
  bannerImage: "",
  bgImage: "",
  title: "At Jeyshawn Engineering Limited, our marine support services includes provision and management of marine vessels for transportation, offshore logistics, towing, anchor handling, and supply operations.",
  paragraphs: [
    "We support offshore installations, pipeline laying, platform maintenance, subsea works, and field development activities with experienced marine crews and well-maintained assets.",
    "We operate in full compliance with international maritime standards, client specifications, and regulatory requirements, with strong emphasis on safety, environmental protection, and operational excellence. Through effective planning, coordination, and real-time marine operations management, we help clients minimize risks, reduce downtime, and maintain continuous offshore operations.",
    "Our marine expertise supports shallow water, deepwater, and near-shore projects, delivering dependable marine solutions tailored to the unique demands of the oil and gas industry.",
  ],
  sections: [],
};

export default function Marine() {
  const { pageData, loading, fetchErr, fetchData, modalOpen, setModalOpen, saving, handleSave, saveMsg } =
    usePageEditor("/api/marine-support", DEFAULT_DATA);

  const bannerImg = resolveUrl(pageData.bannerImage) || Avatar1;
  const bgImg     = resolveUrl(pageData.bgImage)     || Aboutbg;

  return (
    <>
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={fetchData}>Retry</button></div>}
      {modalOpen && (
        <ServiceEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} pageLabel="Marine Support" />
      )}

      <div className="img_carrierss">
        <img src={bannerImg} alt="" />
      </div>

      <section className="service-detail" style={{ backgroundImage: `url(${bgImg})` }}>
        <div className="service-detail__layout">
          <div className="service-detail__content">
            <h2 className="service-detail__title">{pageData.title}</h2>
            <span className="service-detail__divider" />
            {pageData.paragraphs.map((p, i) => <p key={i} className="service-detail__intro">{p}</p>)}
            {pageData.sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => <li key={j} className="service-detail__list-item">{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink key={s.href} to={s.href} className={({ isActive }) => `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`}>
                {s.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
